import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";
import moment from "moment/moment";
import {STATO_ORDINE} from "./Ordine";


@Injectable({
   providedIn: 'root'
})
export class ProdottoFactory {

   constructor(private serverSrv: ServerService,
               private dataSrv: DataService) {
   }

   async getProdotto(prodotto_id, vendorSlug=null):Promise<Prodotto> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/prodotti/${prodotto_id}` : `/api/prodotti/${prodotto_id}`
      return new Promise<Prodotto>((resolve, reject) => {
         ServerService.instance.get(Prodotto, url).then(prodotto=>{
            resolve(prodotto)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async getVendorProdotto(prodotto_id, vendorSlug=null):Promise<Prodotto> {
      let url = `/api/esercizi/${vendorSlug}/vendorproducts/${prodotto_id}`
      return new Promise<Prodotto>((resolve, reject) => {
         ServerService.instance.get(Prodotto, url).then(prodotto=>{
            resolve(prodotto)
         }).catch(err=>{
            reject(err)
         })
      })
   }


   async editProdotto(prodotto_id, data, vendorSlug):Promise<Prodotto> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/vendorproducts/${prodotto_id}` : `/api/prodotti/${prodotto_id}`
      return new Promise<Prodotto>((resolve, reject) => {
         ServerService.instance.put(url, data, Prodotto).then(prodotto=>{
            resolve(prodotto)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async postProdotto(data, vendorSlug=null){
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/vendorproducts` : `/api/prodotti`
      return new Promise<Prodotto>((resolve, reject) => {
         ServerService.instance.post(url, data, Prodotto).then(prodotto=>{
            resolve(prodotto)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async approvaProdotto(prodottoId) {
      return new Promise((resolve, reject) => {
         ServerService.instance.put( `/api/prodotti/${prodottoId}/approva`, {}, Prodotto).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   uploadImage(prodotto_id, files: any) {
      let url = `/api/prodotti/${prodotto_id}/uploadimage`
      return new Promise<boolean>((resolve, reject) => {
         this.serverSrv.uploadFile(url, files)
            .then(res=>{resolve(true)})
            .catch(err=>{reject(err)})
      })
   }


   async getProdottoCodice(vendorSlug, codiceColoreEan: any):Promise<Prodotto> {
      return new Promise((resolve, reject) => {
         ServerService.instance.get(Prodotto, `/api/esercizi/${vendorSlug}/prodotti?codice=${codiceColoreEan}`).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }


   async deleteProdotto(prodotto_id, vendorSlug=null) {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/vendorproducts/${prodotto_id}` : `/api/prodotti/${prodotto_id}`
      return new Promise((resolve, reject) => {
         ServerService.instance.delete(url, {}, Prodotto).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }
}

export class ProdottoData {
   id?: number;
   nome?: string;

   brand?: number;
   year?: number;
   image?:any;
   descrizione?:string;
   stagione?:string;
   target_sesso?:string;
   target_eta?:string;
   brand__name?: string;

   metrica_1?: number;
   metrica_2?: number;
   metrica_3?: number;
   index_met_1?:number | null;
   index_met_2?:number | null;
}

export class Prodotto {

   data:ProdottoData = {}

   constructor(data:ProdottoData) {
      // assegno al mio oggetto data (è un json)
      if(!data) data = {}
      Object.assign(this.data, data)
   }

   public static BASE_URL(path=null, queryParams={}):string{
      let url:UrlObj = new UrlObj(`/api/prodotti`, queryParams);
      if(path) url.url += path;
      return url.toString()
   }

   public static STAGIONI = [
      {value:'ND', display:"Non definito", text:"Non definito"},
      {value:'ALL', display:"Tutte le stagioni", text:"Tutte le stagioni"},
      {value:'PE', display:"Primavera/Estate", text:"Primavera/Estate"},
      {value:'AI', display:"Autunno/Inverno", text: "Autunno/Inverno"},
      {value:'P', display:"Primavera", text: "Primavera"},
      {value:'E', display:"Estate", text:"Estate"},
      {value:'A', display:"Autunno", text: "Autunno"},
      {value:'I', display:"Inverno", text: "Inverno"}
   ]

   public static TARGET_SESSO = [
      {value:'ND', display:"Non definito", text:"Non definito"},
      {value:'U', display:"Uomo", text:"Uomo"},
      {value:'D', display:"Donna", text:"Donna"},
      {value:'UNI', display:"Unisex", text:"Unisex"}
   ]

   public static TARGET_ETA = [
      {value:'NEO', display:"Neonati", text:"Neonati"},
      {value:'BMB', display:"Bambini/e", text:"Bambini" },
      {value:'RGZ', display:"Ragazzi/e", text:"Ragazzi"},
      {value:'ADL', display:"Adulti", text:"Adulti"},
      {value:'ND', display:"Non definito", text:"Non definito"}
   ]

   public static getYearsFilters(){
      let anniStagione: any[] = []
      let actualYear:any = moment()
      let yearsAgo:any = moment(actualYear).subtract(7, "years").year()
      for (let i = 0; i < 10; i++) {
         anniStagione.push({value:yearsAgo, display:yearsAgo})
         yearsAgo += 1
      }
      return anniStagione
   }

   public static getYears(){
      const anniStagione: YearChoice[] = this.generateYearChoices(2022, 2);
      return anniStagione
   }

   private static generateYearChoices(startYear: number, numberOfYears: number): YearChoice[] {
      const yearChoices: YearChoice[] = [];

      let year_today = moment().year()
      let endYear = Number(year_today) + Number(numberOfYears);
      for (let year = startYear; year <= endYear; year++) {
         yearChoices.push({ value: year, display: year.toString() });
      }
      return yearChoices;
   }

}

interface YearChoice {
   value: number;
   display: string;
}
